const createCurrencyString = (
  locale: string,
  currencyType: string,
  amount: any,
  maximumFractionDigits?: number,
) => {
  try {
    return Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyType,
      maximumFractionDigits,
    }).format(amount);
  } catch {
    return '';
  }
};

export default createCurrencyString;
